module.exports = __webpack_public_path__ + "img/avatar_ico2.64641154.jpg";